// extracted by mini-css-extract-plugin
export default {"wrap":"languageSwitcher_wrap__p1wEK","select":"languageSwitcher_select__5Q2-8","visuallyHidden":"languageSwitcher_visuallyHidden__XzTb+"};